module.exports = __webpack_public_path__ + "static/media/gaming13.2e6bf597.webp";